import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-nested-ternary */
import React, { createContext, useReducer, useMemo, useEffect } from 'react';
import moment from 'moment';
import { emptyOption, ALL } from '@mummssoftware/utils/constants';
import { SET_PATIENT_VISITS, SET_CROSSPATIENT_VISITS, SET_PROVIDER_INFO, TOGGLE_FILTERING_ATTRIBUTE, SET_TO_DATE, SET_FROM_DATE, CLEAR_VISIT_FILTER, SET_FILTER_ATTRIBUTES, SET_FILTERED_VISITS, SET_OFFICE_FILTER, UPDATE_FILTERS, SET_TRAVEL_TIME, SET_START_TIME, SET_TOLLS_FEES, SET_MILEAGE, SET_TIME, SET_EDIT_TIME, SET_CC_TIME, SET_REFRESH_VISIT, RESET_REFRESH_VISIT, SET_TRANSIT_FEES, SET_VISIT_TYPES_OPTIONS, SET_VISIT_TYPE_OPTION, SET_DRIVING_VISIT, CLEAR_DRIVING_VISIT, SHOW_DRIVING_EXPIRED_MODAL, HIDE_DRIVING_EXPIRED_MODAL } from './constants';

const initFunction = () => null;

export const blankFilters = {
  fromDate: moment().subtract(31, 'days').toDate(),
  toDate: moment().toDate(),
  officeFilter: ALL,
  minDurationHH: '',
  minDurationMM: '',
  chartAfterDD: '',
  chartAfterHH: '',
  summaryAttributeIds: [],
  summaryAttributeMatchMode: 'AND'
}; // todo: consider collapsing filters into one object (mostly done on stories/OP-31759/story, not merged)
// todo: maybe move officeFilter into visit-summary widget and filteringAttributes/filterAttributes into visit-log (confusing to know which filter is relevant where)
// todo: patientVisitHistory and crossPatientVisitSummary updated by visit-log and visit-summary and only used there. Should we move those down as well?

const initialState = {
  patientVisitHistory: null,
  crossPatientVisitSummary: null,
  dispatchVG: initFunction,
  refreshVisits: 0,
  providerInfo: null,
  filteringAttributes: null,
  fromDate: blankFilters.fromDate,
  toDate: blankFilters.toDate,
  officeFilter: blankFilters.officeFilter,
  filterAttributes: null,
  filteredVisits: null,
  minDurationHH: blankFilters.minDurationHH,
  minDurationMM: blankFilters.minDurationMM,
  chartAfterDD: blankFilters.chartAfterDD,
  chartAfterHH: blankFilters.chartAfterHH,
  summaryAttributeIds: blankFilters.summaryAttributeIds,
  summaryAttributeMatchMode: blankFilters.summaryAttributeMatchMode,
  travelMileage: null,
  transitFees: null,
  travelDuration: null,
  tollsFee: null,
  timerDuration: ['00', '00'],
  editTime: null,
  ccTime: null,
  startTime: null,
  visitTypeOptions: null,
  visitTypeMapping: null,
  visitTypeOption: emptyOption,
  globalDrivingVisit: null,
  drivingExpiredModalOpen: false
};
const initVisitsGlobalContext = initialState;
export const VisitsGlobalContextReducer = (state, action) => {
  let newState = _objectSpread({}, state);

  switch (action.type) {
    case SET_PATIENT_VISITS:
      newState.patientVisitHistory = action.payload;
      break;

    case SET_CROSSPATIENT_VISITS:
      newState.crossPatientVisitSummary = action.payload;
      break;

    case SET_PROVIDER_INFO:
      newState.providerInfo = action.payload;
      break;

    case TOGGLE_FILTERING_ATTRIBUTE:
      newState.filteringAttributes = action.payload.length && action.payload || null;
      break;

    case SET_FROM_DATE:
      newState.fromDate = action.payload;
      break;

    case SET_TO_DATE:
      newState.toDate = action.payload;
      break;

    case SET_OFFICE_FILTER:
      newState.officeFilter = action.payload;
      break;

    case CLEAR_VISIT_FILTER:
      newState.filteredVisits = null;
      newState.filteringAttributes = null;
      break;

    case SET_FILTER_ATTRIBUTES:
      newState.filterAttributes = action.payload;
      break;

    case SET_FILTERED_VISITS:
      newState.filteredVisits = action.payload;
      break;

    case SET_REFRESH_VISIT:
      newState.refreshVisits = state.refreshVisits + 1;
      break;

    case RESET_REFRESH_VISIT:
      newState.refreshVisits = 0;
      break;

    case UPDATE_FILTERS:
      newState.fromDate = action.payload.fromDate;
      newState.toDate = action.payload.toDate;
      newState.officeFilter = action.payload.officeFilter;
      newState.minDurationHH = action.payload.minDurationHH;
      newState.minDurationMM = action.payload.minDurationMM;
      newState.chartAfterDD = action.payload.chartAfterDD;
      newState.chartAfterHH = action.payload.chartAfterHH;
      newState.summaryAttributeIds = action.payload.summaryAttributeIds || [];
      newState.summaryAttributeMatchMode = action.payload.summaryAttributeMatchMode === 'OR' ? 'OR' : 'AND';
      break;

    case SET_MILEAGE:
      newState.travelMileage = action.payload;
      break;

    case SET_TOLLS_FEES:
      newState.tollsFee = action.payload;
      break;

    case SET_TRANSIT_FEES:
      newState.transitFees = action.payload;
      break;

    case SET_TRAVEL_TIME:
      newState.travelDuration = action.payload;
      break;

    case SET_TIME:
      newState.timerDuration = action.payload;
      break;

    case SET_EDIT_TIME:
      newState.editTime = action.payload;
      break;

    case SET_CC_TIME:
      newState.ccTime = action.payload;
      break;

    case SET_START_TIME:
      newState.startTime = action.payload;
      break;

    case SET_VISIT_TYPES_OPTIONS:
      newState.visitTypeOptions = action.payload;
      newState.visitTypeMapping = newState.visitTypeOptions.reduce((seed, x) => {
        seed[x.label] = x.value;
        seed[x.value] = x.value;
        return seed;
      }, {});
      break;

    case SET_VISIT_TYPE_OPTION:
      newState.visitTypeOption = action.payload;
      break;

    case SET_DRIVING_VISIT:
      newState.globalDrivingVisit = action.payload;
      break;

    case CLEAR_DRIVING_VISIT:
      newState.globalDrivingVisit = null;
      newState.drivingExpiredModalOpen = false;
      break;

    case SHOW_DRIVING_EXPIRED_MODAL:
      newState.drivingExpiredModalOpen = true;
      break;

    case HIDE_DRIVING_EXPIRED_MODAL:
      newState.drivingExpiredModalOpen = false;
      break;

    default:
      newState = state;
      break;
  }

  return newState;
};
export const VisitsGlobalContext = /*#__PURE__*/createContext(initVisitsGlobalContext);
export const VisitsGlobalDispatchContext = /*#__PURE__*/createContext({});
export const VisitsGlobalContextConsumer = VisitsGlobalContext.Consumer;
export const VisitsGlobalDispatchContextConsumer = VisitsGlobalDispatchContext.Consumer;
export const VisitsGlobalContextProvider = ({
  children,
  patient // Added patient prop to provide discharge info

}) => {
  const [{
    patientVisitHistory,
    crossPatientVisitSummary,
    refreshVisits,
    providerInfo,
    filteringAttributes,
    fromDate,
    toDate,
    officeFilter,
    filterAttributes,
    filteredVisits,
    minDurationHH,
    minDurationMM,
    chartAfterDD,
    chartAfterHH,
    summaryAttributeIds,
    summaryAttributeMatchMode,
    travelMileage,
    transitFees,
    travelDuration,
    tollsFee,
    editTime,
    ccTime,
    timerDuration,
    startTime,
    visitTypeOptions,
    visitTypeOption,
    visitTypeMapping,
    globalDrivingVisit,
    drivingExpiredModalOpen
  }, dispatch] = useReducer(VisitsGlobalContextReducer, initialState); // if patient is discharged but has not been referred for 90 days then set fromDate to referral date
  // cap at referral date if patient has not been in the hospice longer than 90 days

  useEffect(() => {
    let defaultFromDate;
    const referralDate = (patient === null || patient === void 0 ? void 0 : patient.referralDate) && moment(patient.referralDate);

    if (referralDate && moment().diff(referralDate, 'days') < 90) {
      defaultFromDate = referralDate.toDate();
    } else if (patient !== null && patient !== void 0 && patient.dischargeDate) {
      defaultFromDate = moment(patient.dischargeDate).subtract(90, 'days').toDate();
    } else {
      defaultFromDate = moment().subtract(90, 'days').toDate();
    }

    dispatch({
      type: SET_FROM_DATE,
      payload: defaultFromDate
    });
  }, []);
  const context = useMemo(() => ({
    dispatchVG: dispatch,
    patientVisitHistory,
    crossPatientVisitSummary,
    refreshVisits,
    providerInfo,
    filteringAttributes,
    fromDate,
    toDate,
    officeFilter,
    filterAttributes,
    filteredVisits,
    minDurationHH,
    minDurationMM,
    chartAfterDD,
    chartAfterHH,
    summaryAttributeIds,
    summaryAttributeMatchMode,
    travelMileage,
    transitFees,
    travelDuration,
    tollsFee,
    editTime,
    ccTime,
    startTime,
    timerDuration,
    visitTypeOptions,
    visitTypeOption,
    visitTypeMapping,
    globalDrivingVisit,
    drivingExpiredModalOpen
  }), [patientVisitHistory, crossPatientVisitSummary, dispatch, refreshVisits, providerInfo, filteringAttributes, fromDate, toDate, officeFilter, filterAttributes, filteredVisits, minDurationHH, minDurationMM, chartAfterDD, chartAfterHH, summaryAttributeIds, summaryAttributeMatchMode, travelMileage, transitFees, travelDuration, tollsFee, editTime, ccTime, startTime, timerDuration, visitTypeOptions, visitTypeOption, visitTypeMapping, globalDrivingVisit, drivingExpiredModalOpen]);
  return /*#__PURE__*/React.createElement(VisitsGlobalContext.Provider, {
    value: context
  }, children);
};
export function withVisitsGlobalContext(Component) {
  return function contextComponent(props) {
    return /*#__PURE__*/React.createElement(VisitsGlobalContextConsumer, null, context => /*#__PURE__*/React.createElement(VisitsGlobalDispatchContextConsumer, null, dispatchContext => /*#__PURE__*/React.createElement(Component, _extends({}, props, context, dispatchContext))));
  };
}
export default VisitsGlobalContext;